import React, { useEffect, useState } from "react";
import { GraduationCap, BookOpen, Users, Award } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Loading } from "./ui";

const catIcon = {
  "Lodge of Instruction": GraduationCap,
  Mentoring: Users,
  Reading: BookOpen,
  Officers: Award,
};

export default function Ritual() {
  const [resources, setResources] = useState(null);

  useEffect(() => {
    api.get("/portal/ritual").then((r) => setResources(r.data)).catch(() => setResources([]));
  }, []);

  if (!resources) return <Loading />;

  return (
    <div data-testid="ritual-page">
      <PageTitle eyebrow="Study & Improvement" title="Ritual & Education" sub="Study aids and mentoring materials. Ritual text itself is never reproduced online." />

      <div className="grid gap-5 md:grid-cols-2">
        {resources.map((r) => {
          const Icon = catIcon[r.category] || BookOpen;
          return (
            <Card key={r.id} className="flex gap-5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold/15 text-gold-deep">
                <Icon size={22} />
              </div>
              <div>
                <p className="font-sans text-xs uppercase tracking-widest text-gold-deep">{r.category}</p>
                <h3 className="mt-1 font-display text-xl font-semibold text-sapphire-deep">{r.title}</h3>
                <p className="mt-2 font-sans text-sm text-ink/65">{r.description}</p>
              </div>
            </Card>
          );
        })}
      </div>

      <p className="mt-8 rounded-xl border border-gold/20 bg-gold/5 p-5 font-sans text-sm italic text-ink/65">
        In keeping with Masonic custom, no ritual text, passwords or ceremonial content is reproduced
        on this portal. These resources support memory, understanding and mentoring only.
      </p>
    </div>
  );
}
